import React from "react";
import Accordion from "protocol-setup/components/Accordian";
import { useSetupPermission } from "protocol-setup/helpers";

const SignOffAccordionItem = ({
  title,
  status,
  requestStatusIndex,
  currentDateTime,
  requestStatus,
  open,
  disable,
  currentStatus,
  enableHighlight,
  protectionElement,
  data,
  headerAction,
  isEditMode,
  children
}) => {
  const hasPermission = useSetupPermission(protectionElement);

  return (
    <Accordion
      key={status}
      title={title}
      status={status}
      requestStatusIndex={requestStatusIndex}
      currentDateTime={currentDateTime}
      requestStatus={requestStatus}
      data={data}
      open={open}
      disable={disable}
      currentStatus={currentStatus}
      enableHighlight={enableHighlight}
      isSignOffEditable={hasPermission}
      headerAction={headerAction}
      isEditMode={isEditMode}
    >
      {children}
    </Accordion>
  );
};

export default SignOffAccordionItem;
